module.exports = __webpack_public_path__ + "img/img_19.f720a730.png";